/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

window.DocumentRequirements = {

  _uniqueTypes: ['fs', 'boq'],
  _commonTypes: ['pdf', 'certificate'],

  _resetToDefault(event) {
    return event.field.find('.hide').removeClass('hide');
  },

  _selectAllRequired(event) {
    return $('.document-requirement-required:enabled').prop('checked', $(event.currentTarget).prop('checked'));
  },

  _changeDocumentNameInput(event) {
    let needle;
    const $select = $(event.target);
    const $row = $select.parents('tr');
    if ((needle = $select.val(), Array.from(this._uniqueTypes).includes(needle))) {
      const selectedOptionText = $select.find('option:selected').text();
      $row.find('input.document-name').val(selectedOptionText).prop('readonly', true);
      $row.find('select.participants').val('consultant');
      $row.find('select.participants option:not(:selected)').prop('disabled', true);

      return this._textifyFieldsInRow($row, {omittedFields: ['type']});
    } else {
      $row.find('input.document-name').val('').prop('readonly', false);
      $row.find('select.participants').val('');
      $row.find('select.participants option').prop('disabled', false);

      return this._resetFieldsInRow($row);
    }
  },

  _disableEmptyRows(e){
    let allInputsFilled = true;
    $('.document-requirement-form:not(.hide) tr.new').each((i, tableRow) => {
      if (this._hasOnlyEmptyInputs(tableRow)) {
        return this._disableInputsFor(tableRow);
      } else if (this._hasEmptyInputs(tableRow)) {
        allInputsFilled = false;
        return this._markEmptyInputs(tableRow);
      }
    });

    if (!allInputsFilled) {
      this._enableRowsAndSubmitButton(e.currentTarget);
      e.preventDefault();
    }

    return allInputsFilled;
  },

  _enableRowsAndSubmitButton(form) {
    $('.document-requirement-form:not(.hide) tr.new').find(":input").prop('disabled', false);
    return setTimeout( function() {
      const $submitBtn = $(form).find('input[type="submit"]');
      const originalText = $submitBtn.data('ujs:enable-with');
      return $submitBtn.prop('disabled', false).val(originalText);
    }
    , 1000);
  },

  _markEmptyInputs(element) {
    const $requiredInputs = $(element).find(":input[required]");
    const $emptyInputs = $requiredInputs.filter(this._isEmpty);
    $emptyInputs.closest('td').addClass('error');
    const $filledInputs = $requiredInputs.filter(this._isFilled);
    return $filledInputs.closest('td').removeClass('error');
  },

  _hasEmptyInputs(element) {
    const $requiredInputs = $(element).find(":input[required]");
    if ($requiredInputs.length === 0) { return false; }
    return $requiredInputs.filter(this._isEmpty).length > 0;
  },

  _disableInputsFor(element) {
    return $(element).find(":input").prop('disabled', true);
  },

  _hasOnlyEmptyInputs(element) {
    const $requiredInputs = $(element).find(":input[required]");
    if ($requiredInputs.length === 0) { return false; }
    const $emptyInputs = $requiredInputs.filter(this._isEmpty);
    return $requiredInputs.length === $emptyInputs.length;
  },

  _isEmpty() {
    return !Boolean(this.value);
  },

  _isFilled() {
    return Boolean(this.value);
  },

  _addedTypes() {
    const $trs = $('tr .right input[value="false"]').parents('tr');
    return $trs.find('select.types :selected').map(function() { return $(this).val(); }).get();
  },

  _addRowAndToggleButtons(event) {
    $('.document-requirement-form:not(.hide) .link-to-add').click();
    const $target = $(event.target);
    const $row = $target.parents('tr');
    $row.find('.add-row').toggleClass('hidden');
    $row.find('.remove-row').toggleClass('hidden');
    $row.find('a.remove_nested_fields').removeClass('hidden');
    return $row.addClass('added').removeClass('selected');
  },

  _textifyFieldsInRow($row, options) {
    if (options == null) { options = {}; }
    const omittedFields = options['omittedFields'] || false;
    return $.each($row.find(':input[required]'), (i , input) => {
      let needle;
      if (omittedFields && ((needle = $(input).data('field'), Array.from(omittedFields).includes(needle)))) { return true; }
      const field = $(input).addClass('hidden').data('field');
      let value = '';
      if ($(input).is('select')) {
        value = $(input).find(':selected').text();
      } else {
        value = $(input).val();
      }
      return $row.find(`.placeholder[data-field='${field}']`).html(value).removeClass('hidden');
    });
  },

  _initTypeOptionsInNewRow() {
    const $newRow = $('.document-requirement-form:not(.hide) tr.new:not(.added):last');
    const $options = $newRow.find('select#select-type option');
    return $.each($options, (i, option) => {
      let needle;
      const optionValue = $(option).val();
      if (!(Array.from(this._commonTypes).includes(optionValue)) && (needle = optionValue, Array.from(this._addedTypes()).includes(needle))) {
        return $(option).prop('disabled', true).hide();
      }
    });
  },

  _resetFieldsInRow($row) {
    return $.each($row.find(':input[required]'), (i , input) => {
      const field = $(input).removeClass('hidden').data('field');
      return $row.find(`.placeholder[data-field='${field}']`).html('').addClass('hidden');
    });
  },

  _enableButton(event) {
    return $('input[type="submit"]').prop('disabled', false);
  },

  _propagateDocuments(event){
    const value = $(event.currentTarget).val();
    $('.document-requirement-form').addClass('hide');
    if (value) {
      return $(`#template-${value}`).removeClass('hide');
    } else {
      return $("#template-default").removeClass('hide');
    }
  },

  _disableEnableTemplates(event){
    const isTemplateSelected = $(this).is(':checked');
    $('#document_requirement_templates').prop('disabled', !isTemplateSelected);
    $('.document-requirement-template-enabled').val($('.document-requirement-template').is(':checked'));
    $('.document-requirement-form:not(.hide) .from_template .remove_nested_fields').click();
    if (isTemplateSelected) {
      return $('.document-requirement-form:not(.hide) .from_template.removed').show();
    } else {
      return $('.document-requirement-form:not(.hide) .from_template .remove_nested_fields').click();
    }
  },


  _addOption(event) {
    this._enableButton();
    const $row = $(event.target).parents('tr');
    $row.addClass('removed');
    const selectedType = $row.find('select.types :selected').val();
    if (Array.from(this._uniqueTypes).includes(selectedType)) {
      return $(`option[value='${selectedType}']`).prop('disabled', false).show();
    }
  },

  _initErrorRows() {
    const $newErrorRows = $('.document-requirement-form:not(.hide) tr.new:not(:last)');
    return $.each($newErrorRows, (i, row) => {
      const $row = $(row);
      $row.find('.add-row').toggleClass('hidden');
      $row.find('a.remove_nested_fields').removeClass('hidden');
      $row.addClass('added').removeClass('selected');
      const option = $row.find('select#select-type :selected').val();
      if (Array.from(this._uniqueTypes).includes(option)) { return this._textifyFieldsInRow($row); }
    });
  },

  _addInitialNewRow() {
    return $('.link-to-add').click();
  },

  _hideFieldsMarkedForDestruction() {
      return $('tr .right input[value="true"]').parents('tr').hide();
    },

  _toggleCategorySelect(event) {
    const $target = $(event.currentTarget);
    const $documentCategory = $target.parents('tr').find('.document-category');
    const documentType = $target.parents('tr').find('.types').val();

    if (($target.val() === 'pdf') || ((documentType === 'pdf') && ($target.val() === 'consultant'))) {
      return $documentCategory.removeClass('hidden');
    } else {
      $documentCategory.addClass('hidden');
      return $documentCategory.find('select').val('');
    }
  },

  _initTable() {
    this._addInitialNewRow();
    this._initTypeOptionsInNewRow();
    this._initErrorRows();
    return this._hideFieldsMarkedForDestruction();
  },

  initializeIndex() {
    $(document).on('nested:fieldAdded', _.bind(this._resetToDefault, this));
    $(document).on('click', '#document-requirements-required-all', _.bind(this._selectAllRequired, this));
    $(document).on('submit', 'form', _.bind(this._disableEmptyRows, this));
    $(document).on('click', '.add-row', _.bind(this._addRowAndToggleButtons, this));
    $(document).on('change', '#select-type', _.bind(this._changeDocumentNameInput, this));
    $(document).on('click', '.remove_nested_fields', _.bind(this._addOption, this));
    $(document).on('change', ':input', this._enableButton);
    $(document).on('change', '#document_requirement_templates', _.bind(this._propagateDocuments, this));
    $(document).on('change', '#document_requirement_template', this._disableEnableTemplates);
    $(document).on('change', '.types, select[data-field="participant"]', this._toggleCategorySelect);
    return this._initTable();
  }
};
